const SHELVES = [0, 1, 2, 3, 4, 5, 6].map((i) => 48 + i * 24);
const label = "fill-current text-[9px] font-medium";
const mod = "fill-current text-[8px] font-medium";

const Dim = ({ x1, y1, x2, y2, text, tx, ty, rotate }) => (
  <g className="text-brass">
    <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="currentColor" strokeWidth="0.8" markerStart="url(#tick)" markerEnd="url(#tick)" />
    <text x={tx} y={ty} textAnchor="middle" className={`${label} text-walnut`} transform={rotate ? `rotate(-90 ${tx} ${ty})` : undefined}>{text}</text>
  </g>
);

const Drawer = () => (
  <g data-testid="drawing-drawer" className="text-sheesham" stroke="currentColor" fill="none" strokeWidth="1">
    <rect x="46" y="170" width="43" height="20" /><rect x="91" y="170" width="43" height="20" />
    <line x1="62" y1="174" x2="73" y2="174" strokeWidth="1.6" /><line x1="107" y1="174" x2="118" y2="174" strokeWidth="1.6" />
    <rect x="262" y="170" width="20" height="20" /><path d="M282 180 h14" strokeDasharray="2 2" /><path d="M292 177 l4 3 -4 3" />
    <text x="160" y="183" className={mod}>Drawer module</text>
  </g>
);

const Door = () => (
  <g data-testid="drawing-door" className="text-sheesham" stroke="currentColor" fill="none" strokeWidth="1">
    <rect x="46" y="146" width="43" height="20" /><rect x="91" y="146" width="43" height="20" />
    <circle cx="86" cy="156" r="0.9" fill="currentColor" /><circle cx="94" cy="156" r="0.9" fill="currentColor" />
    <rect x="260" y="146" width="2" height="20" fill="currentColor" />
    <text x="160" y="159" className={mod}>Door module</text>
  </g>
);

const Lift = () => (
  <g data-testid="drawing-lift" className="text-sheesham" stroke="currentColor" fill="none" strokeWidth="1">
    <line x1="44" y1="108" x2="136" y2="108" strokeWidth="2" />
    <line x1="50" y1="120" x2="56" y2="108" /><line x1="130" y1="120" x2="124" y2="108" />
    <rect x="46" y="124" width="88" height="18" strokeDasharray="2 2" />
    <line x1="245" y1="108" x2="279" y2="108" strokeWidth="2" /><line x1="262" y1="120" x2="252" y2="108" />
    <path d="M270 120 v-12" strokeDasharray="2 2" /><path d="M267 111 l3 -4 3 4" />
    <text x="160" y="113" className={mod}>Lift-top, 12 cm up</text>
  </g>
);

const PARTS = { drawer: Drawer, door: Door, lift: Lift };

export const SizeDrawing = ({ modules = ["drawer", "door", "lift"] }) => (
  <figure data-testid="size-drawing" className="rounded-md bg-muted p-4">
    <svg viewBox="0 0 310 250" className="h-auto w-full text-foreground" role="img" aria-label="Pustak Rack front and side view: 100 cm wide, 23.5 cm deep, 212.4 cm tall, 7 shelves 24 cm apart, with drawer, door and lift-top modules in the bays">
      <defs><marker id="tick" viewBox="0 0 6 6" refX="3" refY="3" markerWidth="6" markerHeight="6"><line x1="3" y1="0" x2="3" y2="6" stroke="currentColor" strokeWidth="1" /></marker></defs>
      <g stroke="currentColor" fill="none" strokeWidth="1.2">
        <rect x="40" y="10" width="4" height="212" /><rect x="136" y="10" width="4" height="212" />
        {SHELVES.map((y) => <line key={y} x1="44" y1={y} x2="136" y2={y} strokeWidth="2" />)}
        <rect x="258" y="10" width="24" height="212" />
        {SHELVES.map((y) => <line key={y} x1="258" y1={y} x2="282" y2={y} strokeWidth="2" />)}
      </g>
      {modules.map((m) => { const P = PARTS[m]; return P ? <P key={m} /> : null; })}
      <Dim x1="40" y1="234" x2="140" y2="234" text="100 cm" tx="90" ty="246" />
      <Dim x1="22" y1="10" x2="22" y2="222" text="212.4 cm" tx="14" ty="116" rotate />
      <Dim x1="152" y1="48" x2="152" y2="72" text="24 cm" tx="168" ty="63" />
      <Dim x1="152" y1="192" x2="152" y2="222" text="30 cm" tx="168" ty="210" />
      <Dim x1="258" y1="234" x2="282" y2="234" text="23.5 cm" tx="270" ty="246" />
      <text x="90" y="6" textAnchor="middle" className="fill-current text-[8px] uppercase tracking-widest text-muted-foreground">Front</text>
      <text x="270" y="6" textAnchor="middle" className="fill-current text-[8px] uppercase tracking-widest text-muted-foreground">Side</text>
    </svg>
    <figcaption className="small-print mt-2">Drawing to scale, from our build drawing. Shelf boards are 96.4 cm wide between 18 mm side panels. Every bay is 96.4 x 23.5 x 22.2 cm, so any module fits any bay.</figcaption>
  </figure>
);
